import CustomerBalance from "./CustomerBalance"

export default CustomerBalance
